import PropTypes from "prop-types";
import React from 'react';
import { Link } from "react-router-dom";


const HomeDemoSection = ({subTitle , title, classOption}) => {
    return (
        <div className={`section ${classOption} home-demo-section`} data-aos="fade-up" style={{padding:'50px 0px'}}>
            <span style={{color:'#212529',fontWeight:700, fontSize:'25px'}} className="sub-title">{subTitle}</span>
            {title? <h3  style={{color:'white', fontSize:'2rem',verticalAlign:'middle'}} className="title home-schedule-section-title" dangerouslySetInnerHTML={{__html: title}} /> : ''} 
            <Link style={{marginTop:'20px'}}to={process.env.PUBLIC_URL + "/contact"} id="btn_hover" className="btn btn-primary btn-hover-secondary btn-blue">Let&apos;s  Get Started</Link>

        </div>
    )
}

HomeDemoSection.propTypes = {
    subTitle: PropTypes.string,
    title: PropTypes.string,
    classOption: PropTypes.string
};
HomeDemoSection.defaultProps = {
    classOption: "section-title-two"
};

export default HomeDemoSection;
